<button immoIconButton [theme]="theme()" [size]="size()" [outlined]="outlined()" [icon]="icon()" (click)="changeMode()"></button>
